// src/auth/msalInstance.ts
import type { IPublicClientApplication } from "@azure/msal-browser";

let _instance: IPublicClientApplication | null = null;

export function setMsalInstance(instance: IPublicClientApplication) {
    _instance = instance;
}

export function getMsalInstance(): IPublicClientApplication {
    if (!_instance) {
        throw new Error("MSAL instance not set. Call setMsalInstance(instance) at app startup.");
    }
    return _instance;
}
